import React from 'react';
import cn from 'classnames';
import isString from 'lodash/isString';
import Cell from './Cell';
import Label from '@dealroadshow/uikit/core/components/Badge/Label';
import { BodyCell } from '@dealroadshow/uikit/core/components/Table/DataTable';
import { getSectorRoute } from '@/finsight/Router/RouteWithRedirect/getNewRoute';
import { ISector } from '@/finsight/domain/vo/issuePipeline/IIssuePiplineItem';
import { IFilling } from '@/finsight/domain/vo/Filings/Filings';

import filingsCellsStyles from './filingsCells.scss';
import text from '@dealroadshow/uikit/core/styles/helpers/text.scss';

const getCellContent = ({ color, abbreviation }: ISector, href: string) => (
  <Label
    className={ cn(filingsCellsStyles.sectorLabel, { [filingsCellsStyles.clickable]: !!href }) }
    backgroundColor={ color || '#efefef' }
  >
    { abbreviation }
  </Label>
);

const getTooltipContent = (content: string | string[]) => (
  isString(content) ? content : content.map((item) => (<div key={ item }>{ item }</div>))
);

interface ICellData {
  row: IFilling,
}

const getCell = ({ row: { data, edgarAssetClasses, deal } }: ICellData) => {
  let { sector, subsector } = deal || {};

  const queryString = `?products=${
    encodeURI(deal?.product?.abbreviation)
  }&regions=${
    encodeURI(deal?.country?.region?.abbreviation)
  }`;

  if (edgarAssetClasses && !deal) {
    sector = edgarAssetClasses.find((item) => item.sector)?.sector;
  }

  if (!sector) {
    return null;
  }

  const href = deal ? `${ getSectorRoute(sector.name, subsector.name) }${ queryString }` : '';
  const tooltipData = deal ? `${ sector.name }: ${ subsector.name }` : data['SEC-HEADER']['ABS-ASSET-CLASS'];
  const tooltip = <div className={ text.capitalize }>{ getTooltipContent(tooltipData) }</div>;

  const content = getCellContent(sector, href);

  return <Cell { ...{ tooltip, href, content } } />;
};

interface ISectorCellProps {
  rowIndex: number,
  filing: IFilling,
}

const SectorCell = ({ rowIndex, filing }:ISectorCellProps) => (
  <BodyCell
    name="SectorCell"
    dataTest="sectorCell"
    className={ cn(filingsCellsStyles.unstyledLink, filingsCellsStyles.mainField) }
    rowIndex={ rowIndex }
    rowData={ filing }
    cellCallback={ getCell }
  />
);

export default SectorCell;
